import { render, staticRenderFns } from "./Anchor.vue?vue&type=template&id=906c67ac&"
import script from "./Anchor.vue?vue&type=script&lang=js&"
export * from "./Anchor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports